import { ApiError } from "utils/api/models/api-error";
import { useQuery } from "react-query";
import ApiResult from "utils/api/models/api-result";
import { TechnicanSceduledAppointment } from "models/technicians";
import { GetTechnicansScheduledAppointments } from "services/technicians";

export default function useTechnicanScheduledAppointments(
  startDate: string,
  endDate: string,
  page: number,
  perPage: number
) {
  const queryKey = [
    "technican-scheduled-appointments",
    startDate,
    endDate,
    page,
    perPage,
  ];
  return {
    ...useQuery<ApiResult<TechnicanSceduledAppointment[]>, ApiError>(
      queryKey,
      () =>
        GetTechnicansScheduledAppointments(startDate, endDate, page, perPage),
      {
        staleTime: 10000,
        enabled: !!startDate && !!endDate,
        keepPreviousData: true,
      }
    ),
  };
}
